export const RouteBase = 'legal'
export const Slugs = {
    TOS: 'tos',
    TOS_PREVIOUS: 'previous-tos',
    HIPAA: 'hipaa',
    PRIVACY: 'privacy',
    PRIVACY_PREVIOUS: 'previous-privacy',
    DATA_RETENTION: 'retention',
    COOKIE: 'cookie-policy',
    PAYROLL: 'payroll-tos',
} as const